import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import TimeToHireRole from '../charts/TimeToHireRole';
import TimeToHireSeniority from '../charts/TimeToHireSeniority';
import TimeToHireTech from '../charts/TimeToHireTech';
import {
  StyledCard,
  StyledCardTitle,
  StyledContainer,
  StyledContent,
  StyledData,
  StyledDataItem,
  StyledHeader,
  StyledSource,
  StyledValue,
  StyledValueNumber,
  StyledWrapper
} from './DurationAndCosts.styled';

const TimeToHire: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  const techSectorData = [
    {
      value: 49,
      desc: 'state-of-hiring.time-to-hire.tech-sector.time-to-hire-tech'
    },
    {
      value: 46,
      desc: 'state-of-hiring.time-to-hire.tech-sector.time-to-hire-manfred'
    },
    {
      value: 42,
      desc: 'state-of-hiring.time-to-hire.tech-sector.time-to-hire-recurrent'
    }
  ];

  const successData = [
    {
      value: 59,
      desc: 'state-of-hiring.time-to-hire.success.unsuccessful'
    },
    {
      value: 46,
      desc: 'state-of-hiring.time-to-hire.success.successful'
    }
  ];

  const locationData = [
    {
      value: 60,
      desc: 'state-of-hiring.time-to-hire.location.on-site'
    },
    {
      value: 47,
      desc: 'state-of-hiring.time-to-hire.location.remote'
    }
  ];

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <Heading2 editorial>
            <HtmlTrans
              i18nKey="state-of-hiring.time-to-hire.title"
              ns="state-of-hiring"
            />
          </Heading2>
          <div>
            <HtmlTrans
              i18nKey="state-of-hiring.time-to-hire.desc"
              ns="state-of-hiring"
            />
          </div>
        </StyledHeader>
        <StyledContent>
          <div>
            <StyledCard>
              <StyledCardTitle>
                <HtmlTrans
                  ns="state-of-hiring"
                  i18nKey="state-of-hiring.time-to-hire.tech-sector.title"
                />
              </StyledCardTitle>
              <StyledData>
                {techSectorData.map((item, index) => (
                  <StyledDataItem key={index}>
                    <StyledValue>
                      <StyledValueNumber>{item.value}</StyledValueNumber>
                      <span> {t('state-of-hiring.time-to-hire.days')}</span>
                    </StyledValue>
                    <span>
                      <HtmlTrans ns="state-of-hiring" i18nKey={item.desc} />
                    </span>
                  </StyledDataItem>
                ))}
              </StyledData>
              <StyledSource>
                <strong>
                  *{t('state-of-hiring.time-to-hire.tech-sector.source')}:
                </strong>{' '}
                {t('state-of-hiring.time-to-hire.tech-sector.source-name')}
              </StyledSource>
            </StyledCard>
            <StyledCard>
              <StyledCardTitle>
                <HtmlTrans
                  ns="state-of-hiring"
                  i18nKey="state-of-hiring.time-to-hire.rol.title"
                />
              </StyledCardTitle>
              <TimeToHireRole />
            </StyledCard>
            <StyledCard>
              <StyledCardTitle>
                <HtmlTrans
                  ns="state-of-hiring"
                  i18nKey="state-of-hiring.time-to-hire.main-tech.title"
                />
              </StyledCardTitle>
              <TimeToHireTech />
            </StyledCard>
          </div>
          <div>
            <StyledCard>
              <StyledCardTitle>
                <HtmlTrans
                  ns="state-of-hiring"
                  i18nKey="state-of-hiring.time-to-hire.success.title"
                />
              </StyledCardTitle>
              <StyledData className="vertical">
                {successData.map((item, index) => (
                  <StyledDataItem key={index}>
                    <StyledValue>
                      <StyledValueNumber>{item.value}</StyledValueNumber>
                      <span> {t('state-of-hiring.time-to-hire.days')}</span>
                    </StyledValue>
                    <span>
                      <HtmlTrans ns="state-of-hiring" i18nKey={item.desc} />
                    </span>
                  </StyledDataItem>
                ))}
              </StyledData>
            </StyledCard>
            <StyledCard>
              <StyledCardTitle>
                <HtmlTrans
                  ns="state-of-hiring"
                  i18nKey="state-of-hiring.time-to-hire.location.title"
                />
              </StyledCardTitle>
              <StyledData className="vertical">
                {locationData.map((item, index) => (
                  <StyledDataItem key={index}>
                    <StyledValue>
                      <StyledValueNumber>{item.value}</StyledValueNumber>
                      <span> {t('state-of-hiring.time-to-hire.days')}</span>
                    </StyledValue>
                    <span>
                      <HtmlTrans ns="state-of-hiring" i18nKey={item.desc} />
                    </span>
                  </StyledDataItem>
                ))}
              </StyledData>
            </StyledCard>
            <StyledCard>
              <StyledCardTitle>
                <HtmlTrans
                  ns="state-of-hiring"
                  i18nKey="state-of-hiring.time-to-hire.seniority.title"
                />
              </StyledCardTitle>
              <TimeToHireSeniority />
            </StyledCard>
          </div>
        </StyledContent>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default TimeToHire;
